import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AuthModalContext from '../contexts/AuthModalContext';
import logoLight from './assets/logo.svg';
import logoDark from './assets/logo-gold.svg';

class ResetPassword extends Component {
  static contextType = AuthModalContext;

  constructor(props) {
    super(props);
    this.state = { redirecting: false, isDark: document.documentElement.classList.contains('tw-dark') };
    this._darkObserver = null;
  }

  componentDidMount() {
    // Open the auth modal with forgot password flow after a brief delay
    var modal = this;
    setTimeout(function() {
      modal.context.openAuthModal('login');
      modal.setState({ redirecting: true });
    }, 100);

    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== modal.state.isDark) modal.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._darkObserver) this._darkObserver.disconnect();
  }

  render() {
    if (this.state.redirecting) {
      return <Redirect to="/" />;
    }

    return (
      <div className="tw-min-h-screen tw-bg-[#fafafa] dark:tw-bg-[#0a0a0a] tw-flex tw-items-center tw-justify-center tw-p-4">
        <div className="tw-max-w-md tw-w-full tw-bg-white dark:tw-bg-[#1a1a2e] tw-rounded-2xl tw-shadow-lg tw-p-8 tw-text-center">
          <div className="tw-flex tw-justify-center tw-mb-6">
            <img src={this.state.isDark ? logoDark : logoLight} alt="Primal Market" className="tw-h-14 tw-w-auto" />
          </div>
          <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2">
            Password Reset
          </h2>
          <p className="tw-text-[#666] dark:tw-text-gray-400 tw-text-sm tw-mb-4">
            Password reset links are no longer used. Please use the "Forgot password?" option to reset your password with a verification code.
          </p>
          <p className="tw-text-[#999] tw-text-xs">Redirecting...</p>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
